import React from 'react'
import Highcharts from 'highcharts'
import styled from 'styled-components'
import _ from 'lodash'
import { injectIntl } from 'react-intl'

import Toggle from 'react-toggle'

import 'react-toggle/style.css'

const ToggleWrapper = styled.label`
  display: inline-block;
  margin-right: 24px;
  margin-bottom: 24px;
`

const StyledToggleTrigger = styled(Toggle)`
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
`

const ToggleLabel = styled.span`
  display: inline-block;
  vertical-align: middle;
`

const CHART_OPTIONS = {
  area: {
    type: 'area',
    plotOptions: {
      area: {
        stacking: 'normal'
      }
    }
  },
  column: {
    type: 'column',
    plotOptions: {
      column: {
        pointPadding: 0.2,
        borderWidth: 0,
        stacking: undefined
      }
    }
  },
  line: {
    type: 'line',
    plotOptions: {
      line: {
        lineWidth: 2,
        marker: {
          radius: 4
        }
      }
    }
  },
  stackedColumn: {
    type: 'column',
    plotOptions: {
      column: {
        borderWidth: 0,
        stacking: 'normal'
      }
    }
  }
}

class MultipleTypesChart extends React.Component {
  constructor(props) {
    super(props);

    this.chartContainer = React.createRef();
    this.state = {
      chartType: 'line'
    };
  }

  componentDidMount() {
    this.draw();
  }

  draw() {
    const groupByKey = this.props.territoriesLenght === 1 ? 'produto' : 'territorio';
    const filteredData = this.props.data;
    const categories = _.uniq(_.map(filteredData, 'ano')).sort();
    const series = _.map(_.groupBy(filteredData, groupByKey), (items, key) => {
      const dataByYear = _.map(categories, (year) => {
        const item = _.find(items, { ano: year });
        return item ? item.valor : 0;
      });
      return { name: key, data: dataByYear }
    });
    const sampleItem = _.sample(filteredData)
    const unitName = this.props.intl.formatMessage({
      id: 'survey.charts.multichart_unit_prefix'
    })

    this.chart = Highcharts.chart(this.chartContainer.current, {
      chart: {
        type: 'line',
        backgroundColor: '#F6F5F6'
      },
      title: {
        text: ''
      },
      credits: {
        text: `${ this.props.intl.formatMessage({ id: 'survey.source' }) } ${ this.props.intl.formatMessage({ id: this.props.legendTextKey }) }`,
        // href: this.props.legendUrl
        href: `javascript:window.open("${this.props.legendUrl}", "_blank")`

      },
      xAxis: {
        categories,
        crosshair: true
      },
      yAxis: {
        min: 0,
        title: {
          text: `${unitName} (${ sampleItem.unidade })`
        }
      },
      tooltip: {
        headerFormat: `<span style='font-size:10px'>{point.key} | ${ unitName }: ${ sampleItem.unidade }</span><table>`,
        pointFormat: "<tr><td style='color:{series.color};padding:0'>{series.name}: </td>" +
            "<td style='padding:0'><b>{point.y:,.1f}</b></td></tr>",
        footerFormat: '</table>',
        shared: true,
        useHTML: true
      },
      plotOptions: {
        line: {
          lineWidth: 2,
          marker: {
            radius: 4
          }
        },
      },
      series
    });
  }

  updateChart() {
    const options = CHART_OPTIONS[this.state.chartType];

    this.chart.update({
      chart: {
        type: options.type
      },
      plotOptions: options.plotOptions
    });
  }

  updateChartType(type) {
    this.setState({ chartType: type }, () => {
      this.updateChart();
    })
  }

  render() {
    const chartTypes = [
      {
        key: 'area',
        label: this.props.intl.formatMessage({
          id: 'survey.charts.multichart_chart_name_area'
        })
      },
      {
        key: 'column',
        label: this.props.intl.formatMessage({
          id: 'survey.charts.multichart_chart_name_column'
        })
      },
      {
        key: 'line',
        label: this.props.intl.formatMessage({
          id: 'survey.charts.multichart_chart_name_line'
        })
      },
      {
        key: 'stackedColumn',
        label: this.props.intl.formatMessage({
          id: 'survey.charts.multichart_chart_name_stackedcolumn'
        })
      }
    ];

    return (
      <div>
        { chartTypes.map((item) => {
          return (
            <ToggleWrapper key={ `chart-type-toggle-${ item.key }` }>
              <StyledToggleTrigger
                checked={ this.state.chartType === item.key }
                onChange={ this.updateChartType.bind(this, item.key) } />
              <ToggleLabel>{ item.label }</ToggleLabel>
            </ToggleWrapper>
          );
        }) }
        <div ref={ this.chartContainer } />
      </div>
    );
  }
}

export default injectIntl(MultipleTypesChart)



// WEBPACK FOOTER //
// ./src/components/organisms/ResearchCharts/multiple-types-chart.js